import { FileService } from '../../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy
} from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { Sort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { ADOpportunityByPartnerCSNAndDateRange, Message } from '../../../models/ad-opportunity.model';
import { DatePipe } from '@angular/common';
import { TablefilterMultiplePipe } from '../../../shared/pipes/tablefilter-multiple.pipe';
import { AnnuityListViewModel } from '../../../models/annuity-view.model';
import { NgProgressService } from '../../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-manage-renewals-annuities',
  templateUrl: './manage-renewals-annuities.component.html',
  styleUrls: ['./manage-renewals-annuities.component.css'],
  providers: [DatePipe]
})
export class ManageRenewalsAnnuitiesComponent implements OnInit, OnDestroy {

  title = 'Upcoming Opportunities';
  loadContent = false;

  // export excel
  url: string;
  pageView = 'LTEPROGRAMS';
  keyword: string;

  adOpportunityDetail: ADOpportunityByPartnerCSNAndDateRange;

  narrowMode = false;

  expiryStart = '';
  expiryEnd = '';

  programLogo = 'https://portal.dickerdata.com.au/images/brands/autodesk.jpg';

  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  // filter
  searchField = '';

  selectedVendor = 'Vendors';
  selectedProgramType = '';

  partnerCSN: string;
  partnerName: string;
  // dynamic set date range
  // fromDate = '2020-02-20';
  // toDate = '2020-02-24';

  // set date range
  date = new Date();
  startDate = Date.now();
  endDate = this.date.setDate(this.date.getDate() + 29);
  fromDate;
  toDate;

  messages: Message[] = [];
  // sortedData, Message
  sortedData: Message[];

  hasResult = false;
  filterResultArr: any;

  constructor(
    private activeRouter: ActivatedRoute,
    private manageService: ManageService,
    private fileService: FileService,
    public ngProgress: NgProgressService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.fromDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd' );
    this.toDate = this.datePipe.transform(this.endDate, 'yyyy-MM-dd' );
    this.fromDate = this.datePipe.transform(this.startDate, 'dd-MM-yyyy' );
    this.toDate = this.datePipe.transform(this.endDate, 'dd-MM-yyyy' );

  }

  sortData(sort: Sort) {
    const data = this.messages.filter(x => x.status.toLowerCase() != "completed" && x.status.toLowerCase() != "cancelled").slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name': return compare(a.accounts.end_customer.account.name.toLowerCase(), b.accounts.end_customer.account.name.toLowerCase(), isAsc);
        case 'contrctNo': return compare(a.contract.contract_number.toLowerCase(), b.contract.contract_number.toLowerCase(), isAsc);
        case 'oppNumber': return compare(a.opportunity_number.toLowerCase(), b.opportunity_number.toLowerCase(), isAsc);
        case 'expiryDate': return compare(a.subscription_end_date.split('/').reverse().join('/'), b.subscription_end_date.split('/').reverse().join('/'), isAsc);
        case 'qty': return compare(parseInt(a.total_quantity), parseInt(b.total_quantity), isAsc);

        default: return 0;
      }
    });
  }

  ngOnInit() {

    this.narrowMode = false;
    this.activeRouter.paramMap.subscribe(param => {
      this.ngProgress.start();
      this.partnerName = "";
      this.partnerCSN = param.get('csn');
      this.partnerName = param.get('renewalProgramName');
      if(this.partnerCSN && this.partnerName) {
        $('#levelOne').animate({ scrollLeft: 250 }, 400);
      }
      this.manageService.GetADOpportunityByPartnerCSNAndDateRange(this.partnerCSN, this.fromDate, this.toDate)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: ADOpportunityByPartnerCSNAndDateRange) => {
          this.ngProgress.done();
          this.adOpportunityDetail = res;
          this.messages = this.adOpportunityDetail.output.message;
          this.sortedData = this.messages.filter(x => x.status?.toLowerCase() != "completed" && x.status?.toLowerCase() != "cancelled").slice();
          this.sortedData.forEach(x => x.subscription_end_date = this.datePipe.transform(x.subscription_end_date, 'dd/MM/yyyy'));
        },
          (error: any) => {
            console.info(error);
            this.ngProgress.done();
          });
    });

    // this.manageService.getSubscriptionOrders(this.pageView, 'ADM', this.expiryStart, this.expiryEnd).takeUntil(this.ngUnsubscribe)
    // .subscribe((value: AnnuityListViewModel) => {
    //   this.programLogo = value.programLogo;
    // });

    if (this.router.url !== `/manageRenewalsNew/renewalsEndUser/upComing/${this.partnerName}/${this.partnerCSN}`) {
      this.narrowMode = true;
      this.loadContent = true;  // set to true to avoid load two loading screen at the same time
    }

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // console.log(event.url)
          if (event.url === `/manageRenewalsNew/renewalsEndUser/upComing/${this.partnerName}/${this.partnerCSN}`) {
            this.narrowMode = false;
            $('#levelOne').animate({ scrollLeft: 250 }, 400);
          }
        }
      });

      this.ngProgress.done();

  }

  manageRedirect(opportunityID: string): void {
    this.narrowMode = true;
    this.router.navigate([`./LTEDetails/${opportunityID}`], {
      relativeTo: this.activeRouter,
    });
    // this.manageService.monitorSearchKeyWordChange(contractNumber);
  }

  isActive(opportunityID: string, contractNumber: string): boolean {
    if ( this.router.url.includes(opportunityID)) {
      this.manageService.monitorContractChange(contractNumber);
    }
    return this.router.url.includes(opportunityID);
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  close() {
    const previousUrl = this.router.url.split("/",4).join("/");
    this.router.navigateByUrl(previousUrl);
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['name', 'opportunity_number', 'subscription_end_date', 'total_quantity'], this.searchField);
    if (this.filterResultArr.length === 0) {
      this.hasResult = true;

    } else {
      this.hasResult = false;
    }
  }

  filterReset() {
    this.searchField = '';
    this.hasResult = false;
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
